import { Rule } from 'antd/lib/form';
import { Config } from './config';

export const Email = (config?: Config): Rule => ({
  ...config,
  type: 'email',
  required: true,
});
